import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Close } from '@mui/icons-material';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  closeAction: () => void;
  confirmAction: () => void;
}

const backgroundStyling = { backgroundColor: '#FCFCFC' };
const ConfirmModal: React.FC<ConfirmModalProps> = ({ open, closeAction, title, message, confirmAction }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={closeAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: { borderRadius: '24px' },
      }}
    >
      <DialogTitle
        style={{
          ...backgroundStyling,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignSelf: 'center',
        }}
        id="alert-dialog-title"
        className={'media-modal-title'}
      >
        {title}
        <IconButton aria-label="close" onClick={closeAction}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ ...backgroundStyling, borderColor: '#cccccc' }} dividers>
        <div>{message}</div>
      </DialogContent>
      <DialogActions style={backgroundStyling}>
        <Button onClick={confirmAction} color="success">
          {t('confirm')}
        </Button>
        <Button onClick={closeAction} color="error">
          {t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
